module.exports = __webpack_public_path__ + "img/1726036591640-screenshot-1726036541298.png.b32c3ec4.webp";